import { RootState } from '../types'
import { GetterTree } from 'vuex'
import { Notification } from '@/store/notifications/types'

export const getters: GetterTree<Notification, RootState> = {
  getEmailsNotification: state => state.emailsNotification,
  hasEmailsNotification: state => state.emailsNotification.length > 0,
  getGroupEmailsNotification: state => state.groupEmailsNotification,
  hasGroupEmailsNotification: state => state.groupEmailsNotification.length > 0
}
